/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ClientClientType {
    angular.module("meevo.plugins.clientClientType", []);
}